import { defineComponent } from 'vue';
export default defineComponent({
  name: 'NotFound',
  props: {
    msg: {
      type: String,
      default: '抱歉，此页面暂时无法展示'
    }
  }
});